import { QueryClient } from '@tanstack/react-query'

// Cache time: 1 week
export const cacheTime = 1000 * 60 * 60 * 24 * 7

export const cachedNotesQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      cacheTime,
      staleTime: cacheTime,
    },
  },
})
